import { createFileRoute } from "@tanstack/react-router"
import { TeaserLanding } from "@/components/TeaserLanding"

export const Route = createFileRoute("/")({
  component: TeaserLanding,
})
